var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter-banner"},[_c('span',{staticClass:"newsletter-banner__text",on:{"click":_vm.handleOnClick}},[_vm._v(_vm._s(_vm.model.newsletterBannerText))])])}
var staticRenderFns = []

export { render, staticRenderFns }